import { useEffect } from 'react';
import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import policyListStore from './stores/policy-list-store';
import { Outlet, useParams } from 'react-router-dom';
import useExpandCollapse from '../../hooks/expand-collapse-hook';
import currentPortalStore from '../../stores/current-portal-store';
import FontBody1 from '../../components/fonts/font-body1/font-body1';
import { FONT_COLOR } from '../../components/fonts/font-props';
import AHref from '../../components/ahref/ahref';


const PoliesPage: React.FC = () => {
    const expandCollapseStore = useExpandCollapse();
    const params = useParams();

    useEffect(() => {
        policyListStore.load();
        currentPortalStore.load();
    }, []);

    const getInstruction = () => {
        if (params.policyId) {
            return null;
        }

        const learnMoreLink = 'https://returngo.ai/go/kb/return-policy';

        return (
            <>
                Create policy rules to define the return conditions, resolutions, 
                and return methods that are offered to your customers.
                <br />
                <AHref href={learnMoreLink} target="_blank" >
                    <FontBody1 color={FONT_COLOR.ACCENT1}>Learn More</FontBody1>
                </AHref>
            </>
        );
    };

    return (
        <BasePageLayout title="Settings" subTitles={['Return Policy']} instruction={getInstruction()} >
            <Outlet context={expandCollapseStore} />
        </BasePageLayout>
    );
};

export default PoliesPage;
